<template>
    <MainContainer>
        <div class="fibu-buchungsstapel-detail">
            <h2>
                <template v-if="isNew">Neuen Buchungsstapel anlegen</template>
                <template v-else>Buchungsstapel ID {{ id }}</template>
            </h2>
            <div class="fibu-buchungsstapel-detail-fields">
                <FormGroupBuilder
                    :fields="ioFields"
                    :data="data"
                    :refresh="validationRefresh"
                />

                <template v-if="isNew">
                    <b-button
                        type="submit"
                        class="total-btn mr-1"
                        variant="primary"
                        :disabled="busy"
                        @click="dataProvide"
                    >
                        <template v-if="!busy">anlegen</template>
                        <template v-else>
                            <Spinner small variant="light" />
                        </template>
                    </b-button>
                </template>
                <template v-else>
                    <b-button
                        v-if="checkRight('write')"
                        type="submit"
                        class="total-btn mr-1"
                        variant="primary"
                        :disabled="busy"
                        @click="dataProvide"
                    >
                        <template v-if="!busy">Speichern</template>
                        <template v-else>
                            <Spinner small variant="light" />
                        </template>
                    </b-button>
                </template>

                <b-button
                    type="cancel"
                    href="/fibu/buchungsstapel"
                    class="total-btn"
                    variant="outline-secondary"
                >
                    <template v-if="checkRight('write')">Abbrechen</template>
                    <template v-else>Zurück</template>
                </b-button>
            </div>
        </div>
    </MainContainer>
</template>

<script>
import Toaster from "@/mixins/Toaster/Toaster";
import Rights from "@/mixins/Rights/Rights";
import Validation from "@/mixins/Validation/Validation";
import FormGroupBuilder from "@/components/FormGroupBuilder/FormGroupBuilder";
import Spinner from "@/components/Spinner/Spinner";
import MainContainer from "@/components/MainContainer/MainContainer";
import {ApiFactory} from "@/api/ApiFactory";

const FiBuBuchungsstapelApi = ApiFactory.get('fibuBuchungsstapel');

export default {
    name: "FiBuNewBuchungsstapel",
    mixins: [Toaster, Rights, Validation],
    components: {
        MainContainer,
        FormGroupBuilder,
        Spinner
    },
    data() {
        return {
            ioFields: {
                bezeichnung: {
                    key: 'bezeichnung',
                    label: 'Bezeichnung',
                    type: 'buchungsstapelinput'
                }
            },
            filter: [],
            busy: false,
            data: {},
            id: this.$route.params.id
        }
    },
    created() {
        if(!this.isNew) {
            this.fetch();
        }
    },
    methods: {
        async fetch() {
            this.busy = true;

            let response = await FiBuBuchungsstapelApi.getSingle(this.id);

            if (response.ok) {
                this.registerRights(response);
                this.data = response.json;
            }
            this.busy = false;
        },
        async dataProvide() {
            this.busy = true;

            let response = null;
            if(this.isNew) {
                response = await FiBuBuchungsstapelApi.post(this.data)
            } else {
                response = await FiBuBuchungsstapelApi.put(this.id, this.data);
            }

            if(response.ok) {
                this.cleanValidationData(this.ioFields);
                this.makeToast('Erfolgreich gespeichert',
                    'Die Änderungen wurden erfolgreich in der Datenbank gespeichert.'
                );

                this.$router.push({
                    path: `/fibu/buchungsstapel`
                });
            } else {
                this.handleValidationData(response, this.ioFields);
            }
            this.busy = false;
        },
        updateFilter(filter) {
            this.filter = Object.assign({}, filter);
        },
        postProcessCreate(selectedItem, response) {
            selectedItem.id = response.json.id;
            return selectedItem;
        },
        fetchErrorHandling(response) {
            this.handleValidationData(response, this.ioFields);
        },
        postDataSet() {
            this.cleanValidationData(this.ioFields);
        }
    },
    computed: {
        isNew() {
            return this.$route.params.id === 'new';
        }
    }
}
</script>